export default __webpack_public_path__ + "static/media/Motif_logo_white.0a80af3d.svg";